import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73b9e1ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../styles/button.less?vue&type=style&index=0&id=73b9e1ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9e1ac",
  null
  
)

export default component.exports